import { gql } from "apollo-boost";

export default gql`
  mutation Save($item_id: ID!, $item_type: String!, $toggle_save: Boolean) {
    save(item_id: $item_id, item_type: $item_type, toggle_save: $toggle_save) {
      result
    }
  }
`;
